/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { FaTimes } from '../../../../util/reactIcons';
import cornerstone from 'cornerstone-core';
import store from '../../../../store/store';
import { CloseButton, StyledCustomInputBox } from '../../Viewer/renderer/Common/styled/StyledCustomInputBox';
import { updateLayoutElement } from '../../../../actions/LayoutActions';
import { useDispatch } from 'react-redux';

export const WLInputBox = ({ toggleShowInputBox }) => {
  const [value, setValue] = useState({ windowCenter: undefined, windowWidth: undefined });
  const dispatch = useDispatch();

  const onValueChange = (e) => {
    const name = e.target.name;
    const newValue = parseInt(e.target.value);

    if (name === 'windowWidth' && newValue < 1) return; 
    if (isNaN(newValue)) {
      setValue((prevValue) => ({ ...prevValue, [name]: '' }));
      return;
    }

    const state = store.getState((state) => state);
    const { layout } = state;
    const cornerstoneElements = cornerstone.getEnabledElements();
    const currentCornerstoneElement = cornerstoneElements[layout.selectedViewIndex];
    const { viewport } = currentCornerstoneElement;

    viewport.voi[name] = newValue;
    cornerstone.setViewport(currentCornerstoneElement.element, viewport);
    setValue((prevValue) => ({ ...prevValue, [name]: newValue }));
    dispatch(updateLayoutElement(layout.selectedViewIndex, { isFixedWLPreset: true }));
  };


  return (
      <StyledCustomInputBox className='WLInputBox'>
        <CloseButton onClick={() => toggleShowInputBox()}>
          <FaTimes size="1.3em" />
        </CloseButton>

        <span>W</span>
        <input
          name="windowWidth"
          type="number"
          id="windowWidth"
          value={value.windowWidth}
          onChange={(e) => {
            onValueChange(e);
          }}
        />

        <span>L</span>
        <input
          name="windowCenter"
          type="number"
          id="windowCenter"
          value={value.windowCenter}
          onChange={(e) => {
            onValueChange(e);
          }}
        />

        
      </StyledCustomInputBox>
  );
};
export default WLInputBox;